module.exports = __webpack_public_path__ + "static/media/gh10.68008e68.png";